import {defaultTime} from "../utils/utils";

const speed = (state = defaultTime, action)=>{
    if(action.type === "SET_SPEED"){
        state = action.speed
    }
    return state;
}

export default speed;